import Phaser from 'phaser';
import type { DataByteKind, GridPoint } from '../types';

export const DATA_BYTE_VALUES: Record<DataByteKind, number> = {
  standard: 10,
  bonus: 30,
  'security-key': 45,
  'bandwidth-token': 25,
};

export class DataByte extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, readonly kind: DataByteKind, readonly cell: GridPoint, x: number, y: number, reducedMotion: boolean) {
    super(scene, x, y);
    scene.add.existing(this);
    this.setDepth(9);
    const colors: Record<DataByteKind, number> = { standard: 0x1ed8ff, bonus: 0xff8a34, 'security-key': 0x56e39f, 'bandwidth-token': 0x9d7cff };
    const symbols: Record<DataByteKind, string> = { standard: '◆', bonus: '✦', 'security-key': '⌑', 'bandwidth-token': '»' };
    const glow = scene.add.circle(0, 0, kind === 'standard' ? 15 : 21, colors[kind], 0.18);
    const plate = scene.add.rectangle(0, 0, kind === 'standard' ? 15 : 22, kind === 'standard' ? 15 : 22, 0x06152f, 1).setStrokeStyle(3, colors[kind], 1).setAngle(45);
    const symbol = scene.add.text(0, -1, symbols[kind], { fontFamily: 'Arial Black, Arial', fontSize: kind === 'standard' ? '12px' : '16px', color: '#ffffff' }).setOrigin(0.5);
    this.add([glow, plate, symbol]);
    if (!reducedMotion) scene.tweens.add({ targets: glow, scale: 1.35, alpha: 0.03, duration: 520, yoyo: true, repeat: -1 });
  }
}
